import React from 'react';
import PropTypes from 'prop-types';
import AppModalForm from "../../componentsReusable/AppModalForm";
import FileCommentForm from "./FileCommentForm";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import Icon from "../../componentsReusable/Icon";

const FileCommentFormButton = (props) => {
  const { t } = useTranslation('file_comment_form');

  const handleOnUpdate = (updatedFile) => {
      if (props.onUpdated) {
        props.onUpdated(updatedFile);
      }
  }

  return (
    <div
      className={classNames("file-comment-icon", {
        "has-comment": Boolean(props.file.comment)
      })}
      id={`file-comment-icon-${props.file.id}`}
    >
      <AppModalForm
        modalTitle={t("modal_title")}
        form={FileCommentForm}
        formProps={{
          apiFn: {
            update: props.apiFn,
          },
          data: {
            id: props.file.id,
            comment: props.file.comment || ""
          },
          onUpdated: handleOnUpdate
        }}
      >
        <Icon className="fas fa-comment-alt text-white" tooltip={props.file.comment ? props.file.comment : t("comment_empty")}/>
      </AppModalForm>
    </div>
  );
};

FileCommentFormButton.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.number.isRequired,
    comment: PropTypes.string
  }).isRequired,
  apiFn: PropTypes.func.isRequired,
  onUpdated: PropTypes.func,
};

export default FileCommentFormButton;
